import React, { PropTypes } from 'react'
import classNames from 'classnames'
import Price from './Price'

const ControlledRadioGroup = ({ options, radioGroup, selected, isError, onChange, className, showPrice = false }) => (
  <div>
    {options.map(o => (
      <div key={o.id} className="side-radio">
        <label style={{ display: 'block' }} className={(!!selected && o.id === selected.id ? 'option-selected ' : '') + classNames({ "error" : isError })}>
          <div className={(!!selected && o.id === selected.id ? 'option-selected ' : '') + "radio-target"} ></div>
          <input type="radio" name={radioGroup} 
            className={classNames(['controlled-radio-group', className])}
            value={o.id}
            onChange={(evt) => { onChange(evt.target.value); }}
            checked={!!(selected) && o.id === selected.id}
          />
          {o.label} 
          {showPrice && <Price value={o.price} />}
        </label>
      </div>
    ))}
  </div>
)

ControlledRadioGroup.propTypes = {
  className: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired
  })).isRequired,
  radioGroup: PropTypes.string.isRequired,
  selected: PropTypes.shape({
    id: PropTypes.number.isRequired
  }),
  isError: PropTypes.bool,
  onChange: PropTypes.func,
  showPrice: PropTypes.bool,
}

export default ControlledRadioGroup;